// extracted by mini-css-extract-plugin
module.exports = {"weatherCodeWidget":"_2wKSaY1AL8l9Jsno7VXMFM"};